import { Role, User } from "./users.entity";

export class Admin extends User {
  override role!: Role.Admin;
}
